import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);
  const base642 = await pathToBase64(
    `/images/custom/${data?.customTheme}/base64-2.png`
  );

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "6IDgJzqcYN",
        src: base642,
        width: 396.59,
        height: 562.5,
        left: 0,
        top: 0,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
        colorMask: "rgba(14,15,13,0.5)",
      },
      {
        type: "text",
        id: "FL8n_huqir",
        width: 154.87,
        height: 76.09375,
        left: 87.37,
        top: 199.83,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: justify;"><strong><span style="font-size: 55.1px;"><span style="font-family: Arial;"><span style="color: rgba(249,249,249,1);">目录</span></span></span></strong></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "5dJhEIQoUw",
        width: 221.86,
        height: 53.65625,
        left: 87.37,
        top: 275.57,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style=""><em><strong><span style="font-size: 32.65px;"><span style="font-family: Arial;"><span style="color: rgba(255,255,255,1);">CONTENTS</span></span></span></strong></em></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "UcUCvDFJto",
        width: 228.5,
        height: 12.22,
        left: 80.72,
        top: 330.96000000000004,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "#bd150a",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#254061",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Calibri;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "Y4JHcUMwa_",
        width: 38.64,
        height: 309.17,
        left: 961.36,
        top: 141.96,
        viewBox: [38.64, 309.17],
        path: "M 4.83 0 L 33.81 0 Q 38.64 0 38.64 4.83 L 38.64 304.34000000000003 Q 38.64 309.17 33.81 309.17 L 4.83 309.17 Q 0 309.17 0 304.34000000000003 L 0 4.83 Q 0 0 4.83 0 Z",
        fill: "#bd150a",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#254061",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Calibri;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "text",
        id: "HmgigLwK3c",
        width: 44.3,
        height: 40,
        left: 0,
        top: 2.27,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.02px;font-family: 微软雅黑;">PPT</span><span style="font-size: 1.02px;font-family: 微软雅黑;">模板</span><span style="font-size: 1.02px;font-family: 微软雅黑;">http://www.1ppt.com/moban/</span><span style="font-size: 1.02px;font-family: 微软雅黑;">&nbsp;</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 438.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],

    background,
  };
}
